// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lBW2","top":"styles_top__1ifba"};